import React from 'react';
import { ChevronRight, CheckCircle2 } from 'lucide-react';

const Stepper = ({ steps, currentStep, setCurrentStep }) => (
  <div className="flex items-center gap-1.5 sm:gap-2 mb-6 w-full">
    {steps.map((step, idx) => {
      // Green only when the step's mandatory fields are actually complete.
      // Steps without an isComplete flag fall back to position-based state.
      const isComplete = typeof step.isComplete === 'boolean' ? step.isComplete : idx < currentStep;
      return (
      <React.Fragment key={step.key}>
        {idx > 0 && <ChevronRight size={16} className="flex-shrink-0 text-gray-300 dark:text-slate-600" />}
        <button
          type="button"
          onClick={() => setCurrentStep(idx)}
          className={`flex-1 text-center px-3 py-2.5 rounded-lg text-sm font-semibold transition-colors ${
            currentStep === idx
              ? 'bg-blue-600 text-white shadow-sm'
              : isComplete
              ? 'bg-emerald-50 text-emerald-700 border border-emerald-200 dark:bg-emerald-900/20 dark:text-emerald-300 dark:border-emerald-800/40'
              : 'bg-gray-100 text-gray-500 border border-gray-200 dark:bg-slate-700 dark:text-slate-300 dark:border-slate-600'
          }`}
        >
          {currentStep !== idx && isComplete && <CheckCircle2 size={13} className="inline mr-1 -mt-0.5" />}
          {step.label}
        </button>
      </React.Fragment>
      );
    })}
  </div>
);

export default Stepper;
